// extracted by mini-css-extract-plugin
export default {"base":"sidebar_base__lRKFx","right":"sidebar_right__BJRVY","left":"sidebar_left__Pr0pb","open":"sidebar_open__t3Fwm"};